/**
 * Public pricing copy for the live /pricing page.
 *
 * Source of truth: PR #247 (docs/monetization/13_PARTNER_WALLET_AND_DERIVED_PRICING.md
 * §5.2 and docs/monetization/DECISIONS.md ADR-014, -015, -027, -028, -030, -032)
 * as ported to develop. Collection seed ladder: ₹800 / ₹1,000 / ₹1,300 / ₹1,700 /
 * ₹2,000 / ₹2,500 (DECISIONS.md open-items table, resolved 2026-10-17).
 * Partner packs: PARTNER_STARTER pay ₹5,000 → 7,000 credits, PARTNER_PRO pay
 * ₹20,000 → 32,000 credits (13 §5.2). 1 credit = ₹1 (ADR-015).
 * No promotional bonuses (ADR-027). No subscriptions (ADR-030).
 */
export const HOST_PRICE_LADDER_INR = [800, 1000, 1300, 1700, 2000, 2500] as const;

export interface PartnerPack {
  name: 'Starter' | 'Pro';
  payInr: number;
  creditsInr: number;
}

export const PARTNER_PACKS: readonly PartnerPack[] = [
  { name: 'Starter', payInr: 5000, creditsInr: 7000 },
  { name: 'Pro', payInr: 20000, creditsInr: 32000 },
] as const;

export function formatInr(amount: number): string {
  return `₹${amount.toLocaleString('en-IN')}`;
}

/** Wording that must never appear on the public pricing page again. */
export const RETIRED_PRICING_PHRASES = [
  'Save 20%',
  'cancel anytime',
  'Free Trial',
  'per month',
  'Unlimited invitations',
  'Most Popular',
  '₹299',
  '₹999',
  'Annual',
] as const;
